import { defineComponent as _defineComponent } from 'vue'
import { computed, onMounted } from 'vue';

import BasicBanner from '@/components/ds/BasicBanner.vue';
import BasicButton from '@/ui-components/BasicButton.vue';
import BasicCard from '@/components/ds/BasicCard.vue';
import Hero from '@/components/ds/Hero.vue';

import { TrackingHelper } from '@/helpers/tracking/tracking-helper';
import { storeToRefs } from 'pinia';
import { useRoutingStore } from '@/stores/pinia/useRoutingStore';

interface ButtonActionPayload {
	url: string;
	action: string;
	label: 'top' | 'bottom';
}

interface ButtonActionList {
	[name: string]: ButtonActionPayload;
}


export default /*#__PURE__*/_defineComponent({
  __name: 'Talent',
  setup(__props) {

const { urlMetadata } = storeToRefs(useRoutingStore());

onMounted(() => {
	TrackingHelper.trackPage('talent');
});

const ASSETS_DIRECTORY = ASSETS_DIR;

const urlList: ButtonActionList = {
	JOB_OFFER: { url: JW_CONFIG.JOBSITE_URL, action: 'open_positions_clicked', label: 'top' },
	BLOG_POST: { url: '/blog/post/justwatch-company-culture/', action: 'learn_more_clicked', label: 'bottom' },
};

const headerOptions = computed(() => ({
	header: urlMetadata?.value?.htmlContentJson['HERO_HEADER'],
	text: urlMetadata?.value?.htmlContentJson['HERO_TEXT'],
	cta: urlMetadata?.value?.htmlContentJson['JOB_OFFERS_BUTTON'],
	backgroundStyle:
		'background:linear-gradient(rgba(0,0,0,0.85) 0%, rgba(0,0,0,0.85) 100%), url(https://static.justwatch.com/backdrop/427302/s1920/Good-Will-Hunting-Der-gute-Will-Hunting) no-repeat center top scroll',
}));

const whoWeAreOptions = computed(() => ({
	header: urlMetadata?.value?.htmlContentJson['WHOWEARE_HEADER'],
	text: urlMetadata?.value?.htmlContentJson['WHOWEARE_TEXT'],
}));

const ourValuesOptions = computed(() => ({
	header: urlMetadata?.value?.htmlContentJson['CARDS_HEADER'],
	text: urlMetadata?.value?.htmlContentJson['CARDS_TEXT'],
	type: 'light' as 'light' | 'dark',
}));

const cardContent = computed(() => [
	{
		key: 'learn',
		header: urlMetadata?.value?.htmlContentJson['CARDS_LEARN_HEADER'],
		text: urlMetadata?.value?.htmlContentJson['CARDS_LEARN_TEXT'],
		imageSrc: `/${ASSETS_DIRECTORY}/img/talent/learn.svg`,
	},
	{
		key: 'deliver',
		header: urlMetadata?.value?.htmlContentJson['CARDS_DELIVER_HEADER'],
		text: urlMetadata?.value?.htmlContentJson['CARDS_DELIVER_TEXT'],
		imageSrc: `/${ASSETS_DIRECTORY}/img/talent/deliver.svg`,
	},
	{
		key: 'create',
		header: urlMetadata?.value?.htmlContentJson['CARDS_CREATE_HEADER'],
		text: urlMetadata?.value?.htmlContentJson['CARDS_CREATE_TEXT'],
		imageSrc: `/${ASSETS_DIRECTORY}/img/talent/create.svg`,
	},
]);

const blogSectionOptions = computed(() => ({
	text: urlMetadata?.value?.htmlContentJson['BLOGPOST_TEXT'],
	cta: urlMetadata?.value?.htmlContentJson['JOB_BLOGPOST_BUTTON'],
}));

const bannerOptions = computed(() => ({
	header: urlMetadata?.value?.htmlContentJson['BANNER_TEXT'],
	buttonLabel: urlMetadata?.value?.htmlContentJson['JOB_OFFERS_BUTTON'],
}));

function redirectRouteTo(options: ButtonActionPayload) {
	const { action, label, url } = options;
	TrackingHelper.trackEvent('userinteraction', { action, label });
	window.open(url, '_blank', 'noopener');
}

return { __sfc: true,urlMetadata, ASSETS_DIRECTORY, urlList, headerOptions, whoWeAreOptions, ourValuesOptions, cardContent, blogSectionOptions, bannerOptions, redirectRouteTo, BasicBanner, BasicButton, BasicCard, Hero }
}

})